import {Button} from "@components/ui";
import Link from "next/link";
import {getStrapiMedia} from "@utils/strapi";
import delve from "dlv";

const Banner = ({Title, CTA, Background}: any) => {
  if (CTA && CTA.href && CTA.isExternal && !CTA.label) {
    return (
      <Link href={{ pathname: CTA.href }} target="_blank">
        <div className="w-full my-4 bg-dark text-white text-center bg-cover bg-center aspect-12x5 flex items-end md:items-center justify-items-center text-center"
             style={{backgroundImage: 'url(' + getStrapiMedia(delve(Background, 'data.attributes.url')) || undefined + ')'}}>
          <div className="mx-auto text-center mb-4 md:mb-0"><h3 className="mx-auto mb-4">{Title}</h3></div>
        </div>
      </Link>
    )
  } else if (CTA && CTA.href && !CTA.isExternal && !CTA.label) {
    return (
      <Link href={CTA.href}>
        <div className="w-full my-4 bg-dark text-white text-center bg-cover bg-center aspect-12x5 flex items-end md:items-center justify-items-center text-center"
             style={{backgroundImage: 'url(' + getStrapiMedia(delve(Background, 'data.attributes.url')) || undefined + ')'}}>
          <div className="mx-auto text-center mb-4 md:mb-0"><h3 className="mx-auto mb-4">{Title}</h3></div>
        </div>
      </Link>
    )
  } else {
    return (
      <div className="w-full my-4 bg-dark text-white text-center bg-cover bg-center aspect-12x5 flex items-end md:items-center justify-items-center text-center"
           style={{backgroundImage: 'url(' + getStrapiMedia(delve(Background, 'data.attributes.url')) || undefined + ')'}}>
        <div className="mx-auto text-center mb-4 md:mb-0"><h3 className="mx-auto mb-4">{Title}</h3>
          {
            CTA && CTA.href ?
              CTA.isExternal ?
                <Button Component={'a'} href={CTA.href}>{CTA.label}</Button> :
                <Link href={CTA.href}><Button>{CTA.label}</Button></Link>: null
          }
        </div>
      </div>
    )
  }
}

Banner.defaultProps = {};

export default Banner;
